import React, { useRef, useState, useEffect } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, CloudDownloadIcon, XCircleIcon } from '@heroicons/react/solid';
import * as PDFJS from 'pdfjs-dist';
import styles from './bookpdf.module.css';
import Loader from './Loader';
var TOOLBAR_HEIGHT = 48;
export var BookPdf = function (_a) {
    var type = _a.type, url = _a.url, title = _a.title, loc = _a.loc, closeBook = _a.closeBook, downloadBook = _a.downloadBook;
    var refDisplay = useRef();
    var _b = useState(), currentPdf = _b[0], setCurrentPdf = _b[1];
    var _c = useState(1), page = _c[0], setPage = _c[1];
    var _d = useState(0), numPages = _d[0], setNumPages = _d[1];
    var _e = useState('1'), pageInput = _e[0], setPageInput = _e[1];
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    PDFJS.GlobalWorkerOptions.workerSrc = 'pdf.worker.js';
    var task = PDFJS.getDocument(url);
    var goToPage = function (target) {
        var clamped = Math.min(Math.max(target, 1), numPages || target);
        setPage(clamped);
        setPageInput(String(clamped));
        if (currentPdf)
            renderPage(currentPdf, clamped);
    };
    var previousPage = function () { return goToPage(page - 1); };
    var nextPage = function () { return goToPage(page + 1); };
    var submitPageInput = function () {
        var target = parseInt(pageInput, 10);
        if (!isNaN(target))
            goToPage(target);
        else
            setPageInput(String(page));
    };
    var keyListener = function (e) {
        var _a;
        if (((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.tagName) === 'INPUT')
            return;
        if ((e.keyCode || e.which) == 37)
            previousPage();
        if ((e.keyCode || e.which) == 39)
            nextPage();
    };
    var renderPage = function (pdf, pageNum) {
        var _a;
        ////////////
        var savedPages = localStorage.getItem('rm_pages');
        var spObj = (_a = JSON.parse(savedPages)) !== null && _a !== void 0 ? _a : {};
        spObj[new URL(url).pathname] = pageNum;
        localStorage.setItem('rm_pages', JSON.stringify(spObj));
        ////////////
        pdf.getPage(pageNum).then(function (page) {
            var scale = 1.1;
            var viewport = page.getViewport({ scale: scale });
            // Prepare canvas using PDF page dimensions
            var canvas = document.getElementById('pdfarea');
            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            // Render PDF page into canvas context
            var renderContext = {
                canvasContext: context,
                viewport: viewport,
            };
            var renderTask = page.render(renderContext);
            page.getTextContent().then(function (textContent) {
                // Assign CSS to the textLayer element
                var textLayer = document.querySelector('.textLayer');
                textLayer.style.left = canvas.offsetLeft + "px";
                textLayer.style.top = canvas.offsetTop + "px";
                textLayer.style.height = canvas.height + "px";
                textLayer.style.width = canvas.width + "px";
                textLayer.style.position = 'absolute';
                textLayer.innerHTML = '';
                PDFJS.renderTextLayer({
                    textContent: textContent,
                    container: textLayer,
                    viewport: viewport,
                    textDivs: [],
                });
            });
            renderTask.promise.then(function () {
                // page rendered
            });
        });
    };
    useEffect(function () {
        var _a, _b;
        ////////////
        var savedPages = localStorage.getItem('rm_pages');
        var spObj = (_a = JSON.parse(savedPages)) !== null && _a !== void 0 ? _a : {};
        var pg = (_b = spObj[new URL(url).pathname]) !== null && _b !== void 0 ? _b : 1;
        ////////////
        task.promise
            .then(function (pdf) {
            setCurrentPdf(pdf);
            setNumPages(pdf.numPages);
            setPage(pg);
            setPageInput(String(pg));
            renderPage(pdf, pg);
            setLoading(false);
        })
            .catch(function (err) {
            console.error(err);
        });
        document.addEventListener('keyup', keyListener, false);
        return function () {
            document.removeEventListener('keyup', keyListener);
        };
    }, []);
    return (React.createElement("div", { className: "fixed inset-0 bg-gray-200 flex flex-col" },
        React.createElement("div", { className: "flex items-center justify-between gap-3 px-3 bg-white border-b border-gray-200 shadow-sm flex-shrink-0 z-50", style: { height: TOOLBAR_HEIGHT } },
            React.createElement("div", { className: "flex items-center gap-2 min-w-0" },
                React.createElement("button", { type: "button", onClick: closeBook, className: "p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100", title: "Back to library" },
                    React.createElement(XCircleIcon, { className: "h-5 w-5", "aria-hidden": "true" })),
                title && React.createElement("span", { className: "text-sm font-medium text-gray-700 truncate" }, title)),
            !loading && (React.createElement("div", { className: "flex items-center gap-1 flex-shrink-0" },
                React.createElement("button", { type: "button", onClick: previousPage, disabled: page <= 1, className: "p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 disabled:opacity-30", title: "Previous page" },
                    React.createElement(ChevronLeftIcon, { className: "h-4 w-4", "aria-hidden": "true" })),
                React.createElement("span", { className: "text-sm text-gray-600 flex items-center gap-1" },
                    React.createElement("input", { value: pageInput, onChange: function (e) { return setPageInput(e.target.value); }, onBlur: submitPageInput, onKeyDown: function (e) { return e.key === 'Enter' && submitPageInput(); }, className: "w-10 text-center border border-gray-300 rounded px-1 py-0.5 text-sm" }),
                    React.createElement("span", null,
                        "of ",
                        numPages || '…')),
                React.createElement("button", { type: "button", onClick: nextPage, disabled: numPages > 0 && page >= numPages, className: "p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 disabled:opacity-30", title: "Next page" },
                    React.createElement(ChevronRightIcon, { className: "h-4 w-4", "aria-hidden": "true" })))),
            React.createElement("button", { type: "button", onClick: function () { return downloadBook(url); }, className: "p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 flex-shrink-0", title: "Download" },
                React.createElement(CloudDownloadIcon, { className: "h-5 w-5", "aria-hidden": "true" }))),
        React.createElement("main", { className: "flex-1 relative overflow-auto" },
            React.createElement("div", { style: { overflow: 'hidden' }, className: "flex justify-center py-4 min-h-full relative" },
                loading && (React.createElement("div", { className: "flex items-center justify-center w-full" },
                    React.createElement(Loader, null))),
                !loading && (React.createElement(React.Fragment, null,
                    React.createElement("canvas", { id: "pdfarea", className: "rounded-sm shadow-md bg-white " + styles.bookDisplay, ref: refDisplay }),
                    React.createElement("div", { className: "textLayer" })))),
            !loading && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "fixed left-0 w-1/6 bg-transparent cursor-pointer", style: { top: TOOLBAR_HEIGHT, bottom: 0 }, onClick: previousPage }),
                React.createElement("div", { className: "fixed right-0 w-1/6 bg-transparent cursor-pointer", style: { top: TOOLBAR_HEIGHT, bottom: 0 }, onClick: nextPage }))))));
};
export default BookPdf;
